<template>
  <div class="row">
    <div class="col-md-3">
      <button
        type="button"
        class="btn btn-sm btn-primary waves-effect waves-themed mr-1"
        @click="addRow()"
        :disabled="btnDisable"
      >
        行追加
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary waves-effect waves-themed mr-1"
        @click="delRow()"
        :disabled="btnDisable"
      >
        行削除
      </button>
    </div>
    <div class="col-md-auto ml-md-auto">
      <!-- <div class="row">
        <div class="col-md-auto contTitle">小計</div>
        <div class="col-md-auto contCnt">
          <input
            type="text"
            class="form-control form-control-sm mr-1 text-right"
            v-model="sum"
            disabled
          />
        </div>
        <div class="col-md-auto contTitle">請求金額</div>
        <div class="col-md-auto contCnt">
          <input
            type="text"
            class="form-control form-control-sm mr-1 text-right"
            v-model="sumTax"
            disabled
          />
        </div>
      </div> -->
    </div>
  </div>
  <div class="demo" id="tableflame">
    <table
      class="table table-sm m-0 tableClaim"
      id="tableDailyReport"
      style="border-right: 1px #ccc solid"
    >
      <thead class="bg-fusion-50">
        <tr>
          <th class="fixhead headReport cwC_1">
            種別<br />（決定、提案、調査）
          </th>
          <th class="fixhead headReport cwC_2">案件名</th>
          <th class="fixhead headReport cwC_3">商談先</th>
          <th class="fixhead headReport cwC_4">場所</th>
          <th class="fixhead headReport cwC_5">内容</th>
          <th class="fixhead headReport cwC_6">売上</th>
          <th class="fixhead headReport cwC_7">仕入</th>
        </tr>
      </thead>
      <tbody>
        <!-- ------------------- -->
        <Mo_dailyReport_row
          v-for="item in items"
          :key="item.c_report_det_rownum!"
          v-bind:item="item"
        ></Mo_dailyReport_row>
        <!-- ------------------- -->
      </tbody>
    </table>
  </div>
</template>
<script lang="ts">
import { Prop, Options, Vue } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { EntityClaimDet } from "furukawa-common/src/common/entity/EntityClaimDet";

import Mo_dailyReport_row from "../molecules/Mo_dailyReport_row.vue";
import { EntityReportDet } from "furukawa-common/src/common/entity/EntityReportDet";

@Options({
  components: {
    vSelect,
    Mo_dailyReport_row,
  },
})
export default class Or_tableDailyReport extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  items: EntityReportDet[];

  sum = "0";
  sumTax = "0";

  btnDisable = false;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  //----------------------
  //モーダル用プロパティ
  //----------------------
  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    //
  }

  /**
   * buttonの有効無効を制御
   */
  eventAdjButton(btnDisableTmp: boolean) {
    this.btnDisable = btnDisableTmp;
  }
  //----------------------
  //基本操作用メソッド
  //----------------------

  delRow() {
    this.items.pop();
  }
  addRow() {
    // if (15 <= this.items.length) {
    //   return;
    // }

    let tmp = new EntityReportDet();

    tmp.c_report_det_id = -1;
    tmp.c_report_det_rownum = this.items.length + 1;
    // tmp.c_claim_det_taxrate = 3;

    this.items.push(tmp);
  }

  getSum(): string[] {
    let res: string[] = [];
    res.push(this.sum);
    res.push(this.sumTax);
    return res;
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
thead > tr {
  border: 1px solid #7289aa;
}
input:disabled {
  background-color: #fff;
}
.headClaim {
  text-align: center;
}
.tableClaim tbody tr {
  border-bottom: 1px solid #ccc;
}

.tableClaim td {
  border-right: 1px solid #ccc;
}
.tableClaim tr > td:last-child {
  border-right: none;
}

.headReport {
  text-align: center;
}

.cwC_1 {
  /* width: 550px; */
  min-width: 110px;
}
.cwC_2 {
  /* width: 80px; */
  min-width: 150px;
}
.cwC_25 {
  min-width: 80px;
}
.cwC_3 {
  min-width: 120px;
}
.cwC_4 {
  min-width: 120px;
}
.cwC_5 {
  min-width: 360px;
}
.cwC_6 {
  min-width: 70px;
}
.cwC_7 {
  min-width: 70px;
}

.tableClaim tr:hover td > input,
.tableClaim tr:hover td > select,
.tableClaim tr:hover td {
  background-color: #dddddd;
}

#tableflame {
  width: 100%;
  overflow-x: auto;
}
#tableDailyReport {
  width: 99%;
  margin: 0 auto !important;
}
</style>
